import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Button, Tooltip, } from 'antd';
import { Resizable } from 'react-resizable';

import { Application } from "@yulintu/freesia-bootstrap";

import PropertyGrid from "../../PropertyGrid/PropertyGrid";
import Sider from "../Sider";

import useDesigner from "../hooks/useDesigner";
import useDesignerMessage from "../hooks/useDesignerMessage";
import useDesignerDispatcher from "../hooks/useDesignerDispatcher";
import getDiagramInfo from "../hooks/useDiagramInfo";

import "./AddonSelectionProperties.less";

export default function Addon(props) {

    const refPropertyGrid = useRef();
    const refRightSiderContext = useRef({
        width: localStorage.plotDesignerRightPanelWidth && parseInt(localStorage.plotDesignerRightPanelWidth) || 330,
        height: 1,
    });

    const dispatcher = useDesignerDispatcher();

    const designer = useDesigner();
    const [flag, setFlag] = useState({});
    const [selectedItem, setSelectedItem] = useState();
    const [selectedItemTypeName, setSelectedItemTypeName] = useState();

    useDesignerMessage(items => {

        let item = items.length > 0 ? items[0] : null;

        let metadata = item ? getDiagramInfo(item.getType()) : null;
        if (metadata?.scope !== "plot") {
            setSelectedItem(null);
            setSelectedItemTypeName(null);
            setFlag({});
            dispatcher("selectSider", { location: props.metadata.location, name: null });
            return;
        }

        let name = metadata?.alias || "未知";
        if (name && item && item.name && item.name.trim())
            name = `${name} - ${item.name}`;

        setSelectedItem(item);
        setSelectedItemTypeName(name);
        dispatcher("selectSider", { location: props.metadata.location, name: props.metadata.name });

    }, "selectedItemsChanged");

    const onResize = useCallback((event, { element, size, handle }) => {

        let width = size.width;
        if (width < 50)
            width = 50;

        refRightSiderContext.current.width = width;
        refPropertyGrid.current.resize(size.width);
        setFlag({});

    }, []);

    const onResizeStart = useCallback((e) => {

        refRightSiderContext.current.dragging = true;
        refRightSiderContext.current.startX = e.screenX;
        refRightSiderContext.current.startWidth = refRightSiderContext.current.width;

    }, []);

    const onResizeStop = useCallback((e) => {

        refRightSiderContext.current.dragging = false;
        refRightSiderContext.current.startX = null;
        refRightSiderContext.current.startWidth = null;

        localStorage.plotDesignerRightPanelWidth = JSON.stringify(refRightSiderContext.current.width);
        refRightSiderContext.current.backupSiderWidth = refRightSiderContext.current.width;

    }, []);

    return <>
        <Resizable style={{ width: refRightSiderContext.current.width }} className={selectedItem ? 'shown' : "hidden"} height={refRightSiderContext.current.height} width={refRightSiderContext.current.width} onResize={onResize} onResizeStart={onResizeStart} onResizeStop={onResizeStop} resizeHandles={['w']}>
            <Sider className="grey diagram-editor" title={selectedItemTypeName ? `属性 - ${selectedItemTypeName}` : null}>
                <PropertyGrid ref={refPropertyGrid} orient="h" showDescription={true} source={selectedItem} />
                {
                    !selectedItem ? <div className="second-text abs-0 noselect-des ">请选择一个部件</div> : null
                }
            </Sider>
        </Resizable>
    </>
}